import { service } from '.'

// enum ProductCategory { phone, accessories, laptop }

export interface Premium {
  id: number
  productCategory: string
  productType: string
  paymentType: string
  scopeType: string
  priceMin: number
  priceMax: number
  premium: string
  fixDeductible: string
  chgDeductible: string
  dealerNo?: string
  createTime?: string
  updateTime?: string
}

// 一次交付／躉繳：single premium
// 分期交付：regular premium
// chgDeductible：置換自付額
// fixDeductible：維修自付額

class PremiumStore {
  private _premiums: Premium[] = []

  getPremiums = async (productType: string) => {
    const res = await service.getPremiums(productType)

    if (res.status === 200) {
      this._premiums = await res.json()
      return Promise.resolve()
    } else {
      const body = await res.json()
      const msg = body?.detail ?? body?.message
      throw new Error(`${msg}, ${res.status}`)
    }
  }

  findMatchingPremiums = (targetProductCategory: string, price: string | number, supNo?: string) => {
    const targetScope = supNo === 'Apple' ? 'Apple' : 'NonApple'
    const numPrice = Number(price)

    return this._premiums.filter(({ productCategory, scopeType, priceMin, priceMax }) => {
      return (
        targetProductCategory === productCategory &&
        (scopeType === targetScope || scopeType === 'ALL') &&
        priceMin <= numPrice &&
        priceMax >= numPrice
      )
    })
  }
  getPremiumsByProductCategoryAndPrice = (targetProductCategory: string, price: string | number, supNo?: string) => {
    return this.findMatchingPremiums(targetProductCategory, price, supNo)
  }
}

export const premiumStore = new PremiumStore()
